import { render, staticRenderFns } from "./text-area.vue?vue&type=template&id=33aacb5a&scoped=true"
import script from "./text-area.vue?vue&type=script&lang=js"
export * from "./text-area.vue?vue&type=script&lang=js"
import style0 from "./text-area.vue?vue&type=style&index=0&id=33aacb5a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33aacb5a",
  null
  
)

export default component.exports